import React, {useEffect} from 'react'
import AfrogotechWhite from "../assets/logo white.png";
import Afrogotech from '../assets/logo.png';
import { useTranslation } from 'react-i18next';
import "../App.css";

export default function DarkModeSide() {
  const {t} = useTranslation();
    const whiteLogo = () => {

        const logo = document.querySelector(".mainLogo");
        if (logo) {
          logo.src = AfrogotechWhite;
        }
      };
    
      const darkLogo = () => {
        const logo = document.querySelector(".mainLogo");
        if (logo) {
          logo.src = Afrogotech;
        }
      };
    
      const setDarkMode = () => {
        document.querySelector("body").setAttribute("data-theme", "dark");
        localStorage.setItem("selectedTheme", "dark");
      };
    
      const setLightMode = () => {
        document.querySelector("body").setAttribute("data-theme", "light");
        localStorage.setItem("selectedTheme", "light");
      };
    
      const selectedTheme = localStorage.getItem("selectedTheme");
    
      useEffect(() => {
        if (selectedTheme === "dark") {
          setDarkMode();
          whiteLogo();
        }
      }, [selectedTheme]);
    
      const toggleTheme = (e) => {
        if (e.target.checked) {
          setDarkMode();
          whiteLogo();
        } else {
          setLightMode();
          darkLogo();
        }
      };

  return (
    <>
        <input id="checkbox_toggle" type="checkbox" className="check"  onChange={toggleTheme} defaultChecked={selectedTheme === "dark"}/>
        <div className="checkbox">
            <label className="slide" htmlFor="checkbox_toggle">
            <label className="toggle" htmlFor="checkbox_toggle" />
            <label className="text" htmlFor="checkbox_toggle">
                {t('Light')}
            </label>
            <label className="text" htmlFor="checkbox_toggle">
            {t('Dark')}
            </label>
            </label>
        </div>
    </>

  )
}
